"use client"

import { useEffect } from "react"
import { Preferences } from "@capacitor/preferences"
import { useTheme } from "next-themes"
import { isCapacitorNative } from "@/lib/capacitor"

const THEME_STORAGE_KEY = "sigma-ui-theme"

/**
 * One-way mirror: next-themes (localStorage) → Capacitor Preferences.
 * Do not read Preferences back into setTheme — that fought next-themes hydration and
 * re-ran whenever setTheme’s identity changed, causing an infinite light/dark loop on native.
 */
export function CapacitorThemePersistence() {
  const { theme } = useTheme()

  useEffect(() => {
    if (!isCapacitorNative()) return
    if (theme === undefined) return

    let cancelled = false
    void (async () => {
      try {
        if (cancelled) return
        await Preferences.set({ key: THEME_STORAGE_KEY, value: theme })
      } catch {
        void 0
      }
    })()

    return () => {
      cancelled = true
    }
  }, [theme])

  return null
}
